import { useViewMode, setViewMode } from '../lib/viewMode';

// Simple / Advanced picker. Inline-styled so it drops cleanly into
// both the Engineer/CEO Tools tab (EngineerProfile) and the detailer's
// settings modal (ThemePickerModal) without depending on either's CSS.
//
// The caller supplies the `heading` element so it matches its context
// (an eng-h3 in the Tools tab, a small uppercase label in the modal).

// Human-readable summary of what Simple keeps, per role.
const SIMPLE_SUMMARY = {
  owner:     'Overview · Schedule · Customers · Revenue · Comms',
  principal: 'Overview · Schedule · Customers · Revenue · Comms',
  detailer:  'Checklist · Tasks · Inbox',
};

export default function ViewModeToggle({ role, heading }) {
  const mode = useViewMode(role);
  const roleLabel = role === 'owner' ? 'CEO' : role === 'detailer' ? 'detailer' : 'COO';
  const summary = SIMPLE_SUMMARY[role] || '';

  const pill = (active) => ({
    flex: 1,
    padding: '10px 12px',
    border: '1px solid ' + (active ? 'var(--blue)' : 'var(--border)'),
    background: active ? 'var(--blue-dim, rgba(37,99,235,0.12))' : 'transparent',
    color: 'var(--text)',
    borderRadius: 'var(--radius, 10px)',
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 700,
    fontFamily: 'inherit',
  });

  return (
    <>
      {heading}
      <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 8, lineHeight: 1.4 }}>
        <strong>Simple</strong> trims the menu to the essentials. <strong>Advanced</strong> shows every tab.
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => setViewMode(role, 'advanced')} style={pill(mode !== 'simple')}>
          Advanced{mode !== 'simple' && <span style={{ color: 'var(--blue)', fontSize: 10, marginLeft: 6 }}>● ON</span>}
        </button>
        <button onClick={() => setViewMode(role, 'simple')} style={pill(mode === 'simple')}>
          Simple{mode === 'simple' && <span style={{ color: 'var(--blue)', fontSize: 10, marginLeft: 6 }}>● ON</span>}
        </button>
      </div>
      <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 8, lineHeight: 1.4 }}>
        {mode === 'simple'
          ? <>Showing only: {summary}. Flip to Advanced anytime to bring the rest back.</>
          : <>Simple would show: {summary}.</>}
        {' '}Applies to your ({roleLabel}) view on this device only.
      </div>
    </>
  );
}
